<template>
<div :class="'flex-col-reverse flex items-center '+ (hAuto?'justify-between':style.gap)">
                <div v-for="(pis,index) in c.tronc" :key="index" 
                :class="'h-0 border-solid '+style.border+' '+color"
                :style="{width:ampladaPisos(index)+'rem'}">
                </div>
                <div v-for="(pis,index) in c.pom" class="flex flex-row justify-around" :style="{width:(ampladaPom(c.pom-2)*c.nPoms)+'rem'}" :key="index" >
                   <!-- <div :class="'flex-col-reverse flex items-center '+  (hAuto?'justify-between h-full':style.gap)" v-for="(pom,index) in c.nPoms" :key="index">
                        <div  
                            :class="'h-0 border-solid border-black '+style.border"
                            :style="{width:ampladaPom(index)+'rem'}">
                        </div>
                    </div>-->
                    <div v-for="(pom,index2) in c.nPoms" :key="index2" :class="'h-0 border-solid '+style.border+' '+color"
                :style="{width:ampladaPom(index)+'rem'}">
                </div>
                </div>
            </div>
</template>
<script setup>
import {defineProps,computed} from 'vue'
import castell from '@/functions/notacioCastell';

const props = defineProps({
    castell:{
        type:String,
        default:"pd4",
        required:true

    },
    mida:{
        type:String,
        default:"mitjana",
        required:false
    },
    hAuto:{
        type:Boolean,
        default:false,
        required:false
    },
    color:{
        type:String,
        default:"border-black",
        required:false
    }
})

const c = castell(props.castell)
const style =computed(()=>{
    if(props.mida=="mitjana"){
        return {
            border:'border-t-[0.188rem]',
            gap:'gap-[0.25rem]'
        }
    }
    else if(props.mida=="terç"){
        return {
            border:'border-t-[0.15rem]',
            gap:'gap-[0.125rem]'
        }
    }
    else if(props.mida=="petit"){
        return {
            border:'border-t-[0.125rem]',
            gap:'gap-[0.125rem]'
        }
    }
    else if(props.mida=="nano"){
        return {
            border:'border-t-[0.125rem]',
            gap:'gap-[0.08rem]'
        }
    }
    else return {
            border:'border-t-[0.188rem]',
            gap:'gap-[0.25rem]'
        }
})

function ampladaPisos(index){
    let amplada = 0.375
    if(c.estructura=='pilar'){
        //Amplada Pinya Pilar   
        if (index<=c.reforços){
        amplada = 1+(c.reforços-index)/4
        }
        else //Ampalda Pis de Pilar
        if(index!==0){
        amplada = 2/4
        }
    }
    else if (c.estructura!=='p'){
        //Amplada Pinya Base
        if(index<=c.reforços){
            if (c.mods==="n") return (3.5+((c.nPoms-1))*2)/4
        amplada = ((5+c.reforços+((c.nPoms-1))*2)-index)/4
        }
        else{
            amplada = (3.5+((c.nPoms-1))*2)/4
        }
}
    if (props.mida=='mitjana') return amplada
    else if (props.mida=='terç') return (amplada*(2/3))
    else if (props.mida=='petit') return (amplada/2)
    else if (props.mida=='nano') return (amplada/2)
}

   


function ampladaPom(index){
    let amplada = 0.375
    if (index==c.pom-1) amplada=0.375
    else amplada=0.625
    
    if (props.mida=='mitjana') return amplada
    else if (props.mida=='terç') return (amplada*(2/3))
    else if (props.mida=='petit') return (amplada/2)
    else if (props.mida=='nano') return (amplada/2)
}
</script>